<template>
    <div class="pay-body">
        <backindex :msg="payMsg"></backindex>
        <!--顶部信息-->
        <div class="pay-title">
            <p class="pay-user">{{$t("account")}}：{{user.username}}</p>
            <p class="pay-coin">{{$t("balancd")}}：<span>{{user.score}}</span>{{$t("coin")}}</p>
        </div>
        <p class="pay-cost">{{$t("payAmount")}}：1{{$t("dollar")}}=600{{$t("coin")}}</p>
        <!--储值方式-->
        <div class="pay-style">
            <p>{{$t("payType")}}：</p>
            <div class="style-area">
                <select name="pays_type">
                    <option value="ebanking_my">E-banking</option>
                    <option value="fpx_my">Myclear FPX</option>
                    <option value="webcash_my">Webcash</option>
                    <option value="7eleven_my">7-eleven</option>
                    <option value="epay_my">epay</option>
                </select>
            </div>
        </div>
        <!--支付选择区域-->
        <div class="pay-area">
            <div :class="{'pay-item':true,'item-select':item.status,}" v-for="(item,index) in payArr" :key="index" @click="selectPay(item,index)">
                <p class="area-one">{{item.payCoin}}{{$t("dollar")}}</p>
                <p class="area-two">{{item.saveCoin}}{{$t("coin")}}</p>
                <p class="area-three"><span>{{$t("giftCoin")}}{{item.addCoin}}</span>={{item.totalCoin}}{{$t("coin")}}</p>
                <div class="dis-count">
                    <img src="../../assets/imgs/zhekou.png" alt="">
                    <p class="dis-num">{{item.disNum}}{{$t("discount")}}</p>
                </div>
            </div>
        </div>
        <div class="pay-btn-old">
            <div class="pay-click" @click="mlpay">{{$t("mlpay")}}</div>
        </div>
        <div class="pay-bottom">
            <pagebottom></pagebottom>
        </div>
    </div>
</template>

<script>
    import backindex from "@/components/common/backindex"
    import pagebottom from "@/components/common/pagebottom"
    export default {
        name: "malaysia",
        components:{
            backindex,
            pagebottom
        },
        mounted: function() {
            this.getUser();
            this.bookId = localStorage.getItem("bookId");
            this.bookId = this.bookId?this.bookId:0;
        },
        data(){
            return{
                user:{},
                bookId:this.$route.query.id,
                payMsg:"在线储值",
                paynum:10,
                pay_pm_id:"ebanking_my",
                //方式选择
                styleFlag:false,
                options:["E-banning","a-banning","b-banningssssss","c-banning"],
                style:"E-banning",
                optionNum:0,
                //支付选项
                payArr:[
                    {payCoin:5,saveCoin:3000,addCoin:300,totalCoin:3300,disNum:9,status:false},
                    {payCoin:10,saveCoin:6000,addCoin:1200,totalCoin:3300,disNum:8,status:true},
                    {payCoin:20,saveCoin:12000,addCoin:3600,totalCoin:15600,disNum:7,status:false},
                    {payCoin:50,saveCoin:30000,addCoin:15000,totalCoin:45000,disNum:5,status:false}
                ]
            }
        },
        methods: {
            getUser:function(){
                this.req.getUser().then(res=>{
                    if(res.data.id>0){
                        this.user = res.data;
                    }
                })
            },
            selectPay(para,num){
                let arr = this.payArr.map((item,index)=>{
                    if(index == num){
                        item.status = true;
                        this.paynum = item.payCoin;
                    }else{
                        item.status = false;
                    }
                    return item;
                });
                this.payArr = arr;
            },
            openStyle(){
               this.styleFlag = !this.styleFlag;
            },
            selectStyle(para,num){
                this.optionNum = num;
                this.styleFlag = false;
                this.style = para;
            },
            mlpay(obj) {
                this.req.recharge(6,this.pay_pm_id,this.paynum,this.bookId).then(res=>{
                    if(res){
                        window.location.href = res.url;
                     }
                });
            }
        }
    }
</script>

<style scoped>
    .pay-body{
        width: 100%;
        height: auto;
    }
    .pay-bottom{
        width: 100%;
        margin-top: 1.5em;
        left: 0;
        bottom: 0;
    }
    .pay-title{
        width: 100%;
        height: 1.12rem;
        border-bottom: 0.02rem solid #e6e6e6;
        box-sizing: border-box;
        padding: 0 0.4rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 700;
    }
    .pay-user,.pay-coin{
        font-size: 0.28rem;
        line-height: 0.28rem;
        color: #4d4d4d;
    }
    .pay-coin span{
        color: #ff1f4f;
    }
    .pay-cost{
        width: 100%;
        padding: 0.4rem;
        box-sizing: border-box;
        font-size: 0.3rem;
        line-height: 0.3rem;
        color: #666666;
        font-weight: 700;
    }
    .pay-style{
        width: 100%;
        padding: 0 0 0.4rem 0.4rem;
        box-sizing: border-box;
        font-size: 0.3rem;
        line-height: 0.3rem;
        color: #666666;
        font-weight: 700;
        display: flex;
        align-items: center;
    }
    /*存储方式*/
    .style-area{
        width: auto;
        box-sizing: border-box;
        border: 0.01rem solid #808080;
        border-radius: 0.08rem;
        display: flex;
        position: relative;
    }
    .style-left{
        padding: 0.12rem 0.26rem;
        font-size: 0.28rem;
        line-height: 0.28rem;
        color: #666666;
    }
    .style-right{
        width: 0.4rem;
        border-left: 0.01rem solid #808080;
        padding: 0.18rem 0;
    }
    .style-right img{
        display: block;
        width: 0.18rem;
        height: 0.14rem;
        margin: 0 auto;
    }
    .style-options{
        width: 100%;
        height: 2rem;
        border: 0.01rem solid #808080;
        border-top: none;
        background: #FFFFFF;
        text-align: center;
        font-size: 0.28rem;
        line-height: 0.28rem;
        color: #666666;
        position: absolute;
        left: -0.01rem;
        top: 100%;
        z-index: 99;
        padding-top: 0.08rem;
        box-sizing: border-box;
        border-radius: 0 0 0.08rem 0.08rem;
        animation: show 0.6s;
        overflow-y: auto;
    }
    .options-item{
        padding: 0.1rem 0;
        overflow: hidden;
    }
    .options-select{
        background: #e6e6e6;
    }
    /*下拉展示动画*/
    @keyframes show {
        from {
            height: 0;
        }
        to {
            height: 2rem;
        }
    }
    .option-img{
        transform: rotate(180deg);
        transition: all 0.4s;
    }
    /*支付选择*/
    .pay-area{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0 0.2rem 0.6rem;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    .pay-item{
        width: 3.46rem;
        height: 1.8rem;
        box-sizing: border-box;
        border: 0.01rem solid #cccccc;
        border-radius: 0.08rem;
        position: relative;
        text-align: center;
        font-weight: 700;
        margin-bottom: 0.4rem;
    }
    .item-select{
        border: 0.05rem solid #ff1f4f;
    }
    .area-one{
        font-size: 0.3rem;
        line-height: 0.3rem;
        color: #ff1f4f;
        padding: 0.28rem 0 0;
    }
    .area-two{
        font-size: 0.28rem;
        line-height: 0.28rem;
        color: #666666;
        padding: 0.2rem 0;
    }
    .area-three{
        font-size: 0.28rem;
        line-height: 0.28rem;
        color: #666666;
    }
    .area-three span{
        color: #ff1f4f;
    }
    .dis-count{
        width: 0.8rem;
        height: 0.8rem;
        position: absolute;
        top: 0;
        right: 0;
    }
    .dis-count img{
        display: block;
        width: 0.8rem;
        height: 0.8rem;
    }
    .dis-num{
        width: 0.8rem;
        font-size: 0.16rem;
        line-height: 0.16rem;
        color: #ffffff;
        position: absolute;
        top: 0.14rem;
        right: -0.14rem;
        transform: rotate(45deg);
        font-weight: 500;
    }
    .pay-btn-old{
        width: 100%;
        box-sizing: border-box;
        padding: 0 0.2rem;
    }
    .pay-click{
        width: 100%;
        height: 0.84rem;
        font-size: 0.32rem;
        color: #FFFFFF;
        line-height: 0.84rem;
        background: #ff1f4f;
        border-radius: 0.08rem;
        text-align: center;
        font-weight: 700;
    }
</style>


// WEBPACK FOOTER //
// src/components/pay/malaysia.vue